import * as React from "react";
import { SVGProps } from "react";
export const ArrowRightDownIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.37499 15.833C8.13899 15.833 7.93399 15.7463 7.75999 15.573C7.58666 15.399 7.49999 15.194 7.49999 14.958C7.49999 14.722 7.58666 14.5173 7.75999 14.344C7.93399 14.17 8.13899 14.083 8.37499 14.083H12.833L3.95799 5.208C3.77799 5.028 3.68799 4.81967 3.68799 4.583C3.68799 4.347 3.77799 4.13867 3.95799 3.958C4.13865 3.778 4.34699 3.688 4.58299 3.688C4.81966 3.688 5.02799 3.778 5.20799 3.958L14.083 12.833V8.375C14.083 8.139 14.17 7.934 14.344 7.76C14.5173 7.58667 14.722 7.5 14.958 7.5C15.194 7.5 15.399 7.58667 15.573 7.76C15.7463 7.934 15.833 8.139 15.833 8.375V14.958C15.833 15.194 15.7463 15.399 15.573 15.573C15.399 15.7463 15.194 15.833 14.958 15.833H8.37499Z"
            fill="currentColor"
        />
    </svg>
);
ArrowRightDownIcon.displayName = "ArrowRightDownIcon";
